var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24UploadOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-upload_outlined",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,2a8,8,0,1,0,8,8A8.009,8.009,0,0,0,10,2Zm.5,14h-1a.5.5,0,0,1-.5-.5V7.33L7.56,8.78a.5.5,0,0,1-.355.148A.5.5,0,0,1,6.85,8.78l-.7-.71a.5.5,0,0,1,0-.71L9.28,4.22A.76.76,0,0,1,9.81,4h.38a.768.768,0,0,1,.53.22l3.13,3.13a.5.5,0,0,1,0,.71l-.71.709a.489.489,0,0,1-.7,0L11,7.33V15.5A.5.5,0,0,1,10.5,16Z",
    transform: "translate(2 2)",
    fill: "#eff9ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24UploadOutlined);
export default __webpack_public_path__ + "static/media/icon-24-upload_outlined.4886c06eefb85f872114de8d9c68ce77.svg";
export { ForwardRef as ReactComponent };